import { EmptyState, FlexColumn, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { SMALL_LIST_ITEM_HEIGHT } from '../../../constants/app';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { useStyles } from '../../../hooks/useStyles';
import {
  loadingSubAccountsState,
  selectedSubAccountIdState,
  subAccountIdsState,
  subAccountsPageState,
  subAccountsState,
} from '../../../storage/subAccounts';
import { SubAccount } from '../../../types/subAccount';
import { VirtualizedPaginatedList } from '../../shared/VirtualizedPaginatedList';
import SubAccountItem from './SubAccountItem';

export function SubAccountList() {
  const { css } = useStyles();
  const subAccountIds = useRecoilValue(subAccountIdsState);
  const setSelectedSubAccountId = useSetRecoilState(selectedSubAccountIdState);
  const resetSelectedSubAccountId = useResetRecoilState(selectedSubAccountIdState);
  const loadingSubAccounts = useRecoilValue(loadingSubAccountsState);
  const paginatedSubAccounts = useRecoilValue(subAccountsState);
  const setSubAccountsPage = useSetRecoilState(subAccountsPageState);

  useEffectOnce(() => {
    return () => {
      resetSelectedSubAccountId();
    };
  });

  const onNewSubAccount = () => {
    setSelectedSubAccountId('');
  };

  return (
    <FlexColumn classNames={css({ height: '100%' })}>
      {(!subAccountIds || !subAccountIds.length) && !loadingSubAccounts && (
        <EmptyState title="No tienes ninguna subcuenta" />
      )}
      {(!subAccountIds || !subAccountIds.length) && loadingSubAccounts && <Loading />}
      {subAccountIds && (
        <VirtualizedPaginatedList<SubAccount>
          ids={subAccountIds}
          loading={loadingSubAccounts}
          onNextPage={setSubAccountsPage}
          paginatedResponse={paginatedSubAccounts}
          itemComponent={SubAccountItem}
          itemSize={SMALL_LIST_ITEM_HEIGHT}
        />
      )}
      <StyledButton
        size="compact"
        shape="square"
        onClick={onNewSubAccount}
        startEnhancer={<MaterialIcon name={'add'} />}
        kind="tertiary"
      >
        Nueva subcuenta
      </StyledButton>
    </FlexColumn>
  );
}
